import { DefaultAbilityAction } from '@core/shared/ability';
import { BaseFeature, FeatureType } from '@core/shared/feature';
export class FeedbackBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/feedback/feature","featureId":"common-feedback"},
      bundledItemModels: ["FeedbackItem"],
      // list is auto-generated by generate-model-ids
      dependencies: ['common-users'],
      abilityActions: [{
        action: DefaultAbilityAction.Manage,
        defaultBias: -1
      }],
      plugins: [{
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'FeedbackAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'FeedbackBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'FeedbackBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {};
  }
}